import { render, staticRenderFns } from "./ConsentStatus.vue?vue&type=template&id=5b6de910&scoped=true&"
import script from "./ConsentStatus.vue?vue&type=script&lang=ts&"
export * from "./ConsentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentStatus.vue?vue&type=style&index=0&id=5b6de910&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6de910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6de910')) {
      api.createRecord('5b6de910', component.options)
    } else {
      api.reload('5b6de910', component.options)
    }
    module.hot.accept("./ConsentStatus.vue?vue&type=template&id=5b6de910&scoped=true&", function () {
      api.rerender('5b6de910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ConsentStatus.vue"
export default component.exports